export default __webpack_public_path__ + "static/media/002-helicopter.22f51435.png";